import React from 'react'
import { Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import fire from "../../Fire"
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {Link} from "react-router-dom";
import swal from 'sweetalert';
export default function Login() {

  const [email,setEmail] = useState("");
const [password,setPassword] = useState("");
let history =useHistory();
const handleSubmit = (event)=>{
  event.preventDefault()
  fire.auth().signInWithEmailAndPassword(email,password)
  .then(()=>{
    swal("Good job!", "You clicked the button!", "success");
  })
  .then(()=>{
    history.push("/quiz")
  })
  .catch((error)=>{
    alert(error)
  })
}
  return (
    <div>
      <div className="container" style={{padding:70}}>
        <div className="row justify-content-center align-items-center">
          <div className="col-md-6">
        <Form onSubmit={handleSubmit}>
<Form.Group className="mb-3" controlId="formBasicEmail">
<Form.Label>Email address</Form.Label>
<Form.Control type="email" placeholder="Enter email" onChange={(ev)=>setEmail(ev.target.value)} required />
</Form.Group>

<Form.Group className="mb-3" controlId="formBasicPassword">
<Form.Label>Password</Form.Label>
<Form.Control type="password" placeholder="Password" onChange={(ev)=>setPassword(ev.target.value)} required/>
</Form.Group>
<Link style={{color:'white',fontWeight:'bold'}} to="/">New Menber Please Signup</Link> <br /><br />
<Button variant="dark" type="submit">
Login
</Button>
</Form>
</div>
<div className="col-md-6 justify-content-center align-items-center">
<img width="500" src="https://cdni.iconscout.com/illustration/premium/thumb/user-login-4268415-3551762.png" alt="" />
</div>
</div>
</div>
    </div>
)
}
